const CopilotStyles = {
    chatContainer: {
        position: "fixed",
        display: "flex",
        flexDirection: "column",
        height: "80vh",
        width: "calc(5 / 7 * 84vh)",
        bottom: "40px",
        right: "20px",
        zIndex: 100000,
        borderRadius: "16px",
        border: "1.5px solid #FFD700",
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
        overflow: "visible",
        backgroundColor: "#fff",
        transition: "all 0.3s ease",
    },
    chatContainerExpanded: {
        height: "100vh",
        width: "100vw",
        bottom: "0",
        right: "0",
        position: "fixed",
        zIndex: 100000,
    },
    header: {
        backgroundColor: "white",
        color: "#000000",
        fontSize: "16px",
        borderTopLeftRadius: "16px",
        borderTopRightRadius: "16px",
        height: "70px",
        fontWeight: "bold",
        textAlign: "center",
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        borderBottom: "1px solid rgba(128, 128, 128, 0.5)",
        position: "relative",
        overflow: "visible",
    },
    headerTitle: {
        fontWeight: "400",
        fontSize: "24px",
        color: "white",
        marginLeft: "10px",
        fontFamily: "System-UI",
    },
    headerLogo: {
        position: "absolute",
        left: "50%",
        top: "0",
        transform: "translate(-50%, -50%)",
        width: "73.45px",
        height: "74.45px",
        pointerEvents: "none",
        zIndex: 1,
    },
    headerLogoExpanded: {
        left: "5.6px",
        top: "50%",
        transform: "translateY(-50%)",
    },
    headerButtons: {
        display: "flex",
        gap: "4px",
        marginLeft: "auto",
        marginRight: "20px",
    },
    headerButton: {
        backgroundColor: "transparent",
        border: "none",
        color: "white",
        cursor: "pointer",
        padding: "5px",
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        transition: "background-color 0.2s ease",
    },
    headerButtonHover: {
        backgroundColor: "rgba(255, 255, 255, 0.1)",
    },
    headerIcon: {
        width: "25px",
        height: "25px",
        strokeWidth: "1px",
    },
    toggleDiv: {
        display: "flex",
        transition: "right 0.5s ease, transform 1.5s ease",
        zIndex: 1050,
        alignItems: "center",
        flexDirection: "column",
        position: "fixed",
        bottom: "20px",
        right: "30px",
    },
    toggleDivOpen: {
        right: "calc(5 / 7 * 84vh + 30px)",
        transform: "rotate(360deg)",
        visibility: "hidden",
    },
    toggleDivOpenRight: {
        left: "calc(5 / 7 * 84vh + 30px)",
        visibility: "hidden",
    },
    toggleDivExpandedRight: {
        left: "calc(60vw + 30px)",
        visibility: "hidden",
    },
    toggleDivExpanded: {
        right: "calc(60vw + 30px)",
        visibility: "hidden",
    },
    copilotToggle: {
        backgroundColor: "transparent",
        border: "none",
        cursor: "pointer",
    },
    copilotToggleImg: {
        width: "73.45px",
        height: "auto",
    },
    messages: {
        flex: 1,
        padding: "5px",
        paddingTop: "20px",
        paddingRight: "20px",
        overflowY: "auto",
        overflowX: "visible",
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#ffffff",
        position: "relative",
    },
    message: {
        padding: "10px 20px",
        borderRadius: "12px",
        margin: "8px 0",
        maxWidth: "100%",
        width: "fit-content",
        animation: "fadeInFromTop 0.5s ease-out",
        wordWrap: "break-word",
        overflowWrap: "break-word",
        display: "flex",
        alignItems: "flex-start",
        position: "relative",
        fontSize: "14px",
        lineHeight: "20px",
        color: "#101827",
        fontFamily: '"IBM Plex Sans", System-UI, sans-serif',
    },
    messageContainer: {
        display: "flex",
        gap: "0px",
        alignItems: "flex-start",
        width: "fit-content",
        justifyContent: "flex-start",
    },
    userMessageContainer: {
        display: "flex",
        gap: "16px",
        alignItems: "baseline",
        width: "100%",
        justifyContent: "flex-end",
    },
    messageAvatar: {},
    messageAvatarImg: {
        width: "100%",
        height: "100%",
        maxWidth: "60px",
        maxHeight: "60px",
        minWidth: "60px",
        minHeight: "60px",
    },
    userMessage: {
        borderTopRightRadius: "0px",
        backgroundColor: "#F1F8FD",
        color: "#101827",
        alignSelf: "flex-end",
        marginRight: "0",
        fontFamily: '"IBM Plex Sans", System-UI, sans-serif',
        maxWidth: "600px",
    },
    botMessage: {
        borderTopLeftRadius: "0px",
        backgroundColor: "#F1F8FD",
        color: "#101827",
        alignSelf: "flex-start",
        maxWidth: "100%",
        marginLeft: "0",
        flex: 1,
    },
    loadingMessage: {
        borderTopLeftRadius: "0px",
        background: "#F1F8FD",
        color: "#101827",
        alignSelf: "flex-start",
        width: "fit-content",
        fontStyle: "italic",
        marginLeft: "0",
        flex: "none",
    },
    inputArea: {
        height: "auto",
        position: "relative",
        padding: "20px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: "12px",
        backgroundColor: "#fff",
        borderTop: "1px solid #E5E7EB",
    },
    chatInput: {
        width: "100%",
        // maxWidth: "600px",
        lineHeight: "24px",
        padding: "12px",
        borderRadius: "8px",
        fontSize: "14px",
        outline: "none",
        resize: "none",
        overflowY: "hidden",
        boxSizing: "border-box",
        border: "1px solid #E5E7EB",
        transition: "all 0.2s ease",
        fontFamily: '"IBM Plex Sans", System-UI, sans-serif',
        backgroundColor: "#fff",
        color: "#101827",
        minHeight: "48px",
        maxHeight: "120px",
    },
    chatInputFocus: {
        borderColor: "#2356f6",
        boxShadow: "0 0 0 2px rgba(35, 86, 246, 0.1)",
    },
    chatInputPlaceholder: {
        color: "#6B7280",
    },
    sendButton: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "white",
        borderRadius: "8px",
        border: "none",
        cursor: "pointer",
        padding: "12px",
        minWidth: "100px",
        height: "100px",
        fontSize: "100px",
        flexShrink: 0,
        transition: "all 0.2s ease",
    },
    sendButtonHover: {
    // backgroundColor: "#0D3F6B",
    },
    sendButtonDisabled: {
        backgroundColor: "white",
        cursor: "not-allowed",
    },
    resendButton: {
        backgroundColor: "#2356f6",
        border: "none",
        cursor: "pointer",
        borderRadius: "50%",
        width: "46px",
        height: "46px",
        margin: "5px",
    },
    resetIcon: {
        color: "white",
        height: "24px",
        width: "24px",
    },
    sendIcon: {
        color: "white",
        height: "24px",
        width: "24px",
    },
    sendIconDisabled: {
        color: "#9CA3AF",
    },
    markdownH1: {
        fontSize: "24px",
        fontWeight: "bold",
        margin: "16px 0 8px",
    },
    markdownH2: {
        fontSize: "20px",
        fontWeight: "bold",
        margin: "16px 0 8px",
    },
    markdownH3: {
        fontSize: "18px",
        fontWeight: "bold",
        margin: "16px 0 8px",
    },
    markdownH4: {
        fontSize: "16px",
        fontWeight: "bold",
        margin: "16px 0 8px",
    },
    markdownH5: {
        fontSize: "14px",
        fontWeight: "bold",
        margin: "16px 0 8px",
    },
    markdownH6: {
        fontSize: "12px",
        fontWeight: "bold",
        margin: "16px 0 8px",
    },
    markdownP: {
        margin: "8px 0",
    },
    inlineCode: {
        fontFamily: "monospace",
        backgroundColor: "#f4f4f4",
        padding: "2px 4px",
        borderRadius: "4px",
    },
    codeBlockWrapper: {
        position: "relative",
        overflowX: "hidden",
        width: "100%",
    },
    copyButton: {
        position: "absolute",
        top: "-4px",
        right: "-4px",
        backgroundColor: "#7b9bfc",
        color: "#fff",
        border: "none",
        borderRadius: "4px",
        padding: "4px 8px",
        cursor: "pointer",
        fontSize: "12px",
    },
    copyButtonInline: {
        marginLeft: "4px",
        backgroundColor: "transparent",
        border: "none",
        color: "#000000",
        cursor: "pointer",
        fontSize: "12px",
    },
    visibleCopyButton: {
        display: "inline-block",
        position: "relative",
        marginLeft: "5px",
        padding: "2px 5px",
        fontSize: "12px",
        backgroundColor: "#f0f0f0",
        border: "1px solid #ccc",
        borderRadius: "3px",
        cursor: "pointer",
    },
    codeBlock: {
        backgroundColor: "#333",
        color: "#fff",
        padding: "16px",
        borderRadius: "4px",
        overflowX: "auto",
        fontFamily: "monospace",
        fontSize: "14px",
        position: "relative",
        whiteSpace: "pre",
    },
    mathBlockWrapper: {
        display: "inline-flex",
        alignItems: "center",
        margin: "16px 0",
        textAlign: "center",
    },
    mathBlock: {
        display: "inline-block",
    },
    inlineMathWrapper: {
        position: "relative",
        display: "inline-block",
    },
    inlineMath: {
        display: "inline",
    },
    markdownUl: {
        margin: "8px 0",
        paddingLeft: "20px",
    },
    markdownOl: {
        margin: "8px 0",
        paddingLeft: "20px",
    },
    markdownLi: {
        margin: "4px 0",
    },
    markdownBlockquote: {
        margin: "8px 0",
        paddingLeft: "16px",
        borderLeft: "4px solid #ccc",
        color: "#666",
    },
    markdownA: {
        color: "#2356f6",
        textDecoration: "underline",
    },
    markdownTable: {
        borderCollapse: "collapse",
        width: "100%",
        margin: "16px 0",
        fontSize: "14px",
        fontFamily: '"IBM Plex Sans", System-UI, sans-serif',
        display: "table",
        tableLayout: "auto",
    },
    markdownThead: {
        backgroundColor: "#f8f9fa",
        display: "table-header-group",
    },
    markdownTh: {
        border: "1px solid #dee2e6",
        padding: "12px 8px",
        textAlign: "left",
        fontWeight: "600",
        color: "#0E497A",
        backgroundColor: "#f8f9fa",
        display: "table-cell",
    },
    markdownTd: {
        border: "1px solid #dee2e6",
        padding: "12px 8px",
        textAlign: "left",
        color: "#101827",
        display: "table-cell",
    },
    markdownTr: {
        display: "table-row",
    },
    markdownTbody: {
        display: "table-row-group",
    },
    walkthroughButtons: {
        display: "flex",
        justifyContent: "center",
        gap: "10px",
        margin: "10px 0",
    },
    walkthroughButton: {
        padding: "8px 16px",
        borderRadius: "20px",
        border: "none",
        cursor: "pointer",
        fontSize: "14px",
        fontWeight: "bold",
        display: "flex",
        alignItems: "center",
        gap: "5px",
    },
    startButton: {
        backgroundColor: "#007bff",
        color: "white",
    },
    startingUserMessages: {
        display: "flex",
        flexDirection: "column",
        gap: "6px",
        padding: "4px 12px",
        height: "100%",
        overflowY: "auto",
        scrollbarWidth: "none",
        msOverflowStyle: "none",
        WebkitOverflowScrolling: "touch",
        alignItems: "center",
        justifyContent: "center",
        fontFamily: "System-UI",
        color: "#888",
    },
    startingUserMessageButton: {
        width: "80%",
        background: "#edf2ff",
        border: "1px solid rgba(35, 86, 246, 0.2)",
        borderRadius: "8px",
        padding: "10px 12px",
        fontSize: "14px",
        color: "#333",
        cursor: "pointer",
        transition: "all 0.2s ease",
        fontFamily: "System-UI",
        textAlign: "center",
    },
    startingUserMessage: {
        margin: "4px 0",
        fontFamily: "System-UI",
    },
    suggestionsArea: {
        display: "flex",
        flexWrap: "nowrap",
        gap: "8px",
        padding: "8px 20px",
        overflowX: "auto",
        maxHeight: "50px",
        justifyContent: "center",
        alignItems: "center",
        scrollbarWidth: "none",
        msOverflowStyle: "none",
        WebkitOverflowScrolling: "touch", // Smooth scrolling on iOS
    },
    suggestionButton: {
        background: "#2B5F75",
        border: "none",
        borderRadius: "20px",
        padding: "8px 16px",
        fontSize: "12px",
        color: "#FFFFFF",
        cursor: "pointer",
        transition: "all 0.2s ease",
        flexShrink: 0,
        whiteSpace: "nowrap",
        fontFamily: '"IBM Plex Sans", System-UI, sans-serif',
        fontWeight: "500",
        minHeight: "32px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    nevermindButton: {
        backgroundColor: "#f0f0f0",
        color: "#333",
    },
    loadingOverlayStyles: {
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(255, 255, 255, 0.8)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1000,
    },
    spinnerStyles: {
        width: "40px",
        height: "40px",
        border: "4px solid #f3f3f3",
        borderTop: "4px solid #2356f6",
        borderRadius: "50%",
        animation: "spin 1s linear infinite",
    },
    form: {
        padding: "20px",
        paddingLeft: "50px",
        background: "transparent",
        width: "100%",
        margin: "0",
        boxSizing: "border-box",
        overflow: "visible", // Allow necessary overflow
    },
    formTitle: {
        color: "#0E497A",
        fontWeight: "bold",
        fontFamily: "IBM Plex Sans, System-UI, sans-serif",
        fontSize: "18px",
        marginBottom: "16px",
    },
    formCancelButton: {
        color: "#0E497A",
        fontFamily: "IBM Plex Sans, System-UI, sans-serif",
        border: "1px solid #0E497A",
    },
    formSubmitButton: {
        color: "#ffffff",
        backgroundColor: "#0E497A",
        fontFamily: "IBM Plex Sans, System-UI, sans-serif",
    },
    footer: {
        padding: "5px",
        textAlign: "center",
        fontSize: "10px",
        color: "#888",
        backgroundColor: "transparent",
        fontFamily: "IBM Plex Sans, System-UI, sans-serif",
    },
    featureTemplatesContainer: {
        display: "flex",
        gap: "50px",
        padding: "20px",
        paddingTop: "0px",
        paddingLeft: "50px",
        paddingRight: "50px",
        overflowX: "auto",
        flexWrap: "nowrap",
        justifyContent: "flex-start",
        alignItems: "center",
        minHeight: "280px",
        marginLeft: "24px",
        scrollbarWidth: "none",
        msOverflowStyle: "none",
    },
    featureTemplateCard: {
        width: "200px",
        height: "230px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        cursor: "pointer",
        position: "relative",
        flexShrink: 0,
        transition: "transform 0.2s ease",
        minWidth: "250px",
        maxWidth: "250px",
        maxHeight: "280px",
    },
    featureTemplateCardHover: {
        transform: "translateY(-10px)",
    },
    featureTemplateIcon: {
        width: "130px",
        height: "130px",
        objectFit: "contain",
        borderRadius: "50%",
        padding: "0",
        margin: "0",
        zIndex: 20000,
    },
    featureTemplateContent: {
        width: "100%",
        height: "100%",
        border: "1px solid #D5DCE4",
        borderRadius: "8px",
        padding: "36px 12px 12px",
        marginTop: "-65px",
        paddingTop: "50px",
        backgroundColor: "#fff",
        display: "flex",
        flexDirection: "column",
        gap: "6px",
        transition: "border-color 0.2s ease",
    },
    featureTemplateContentHover: {
        borderColor: "#0E497A",
    },
    featureTemplateTitle: {
        color: "#0E497A",
        fontSize: "14px",
        fontWeight: 500,
        textAlign: "center",
        marginBottom: "6px",
        fontFamily: '"IBM Plex Sans", System-UI, sans-serif',
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        padding: "0 4px",
    },
    featureTemplateDescription: {
        color: "#3C4E5D",
        fontSize: "12px",
        textAlign: "center",
        lineHeight: "1.3",
        fontFamily: '"IBM Plex Sans", System-UI, sans-serif',
        overflow: "hidden",
        display: "-webkit-box",
        WebkitLineClamp: 2,
        WebkitBoxOrient: "vertical",
        padding: "0 4px",
    },
    filePreview: {
        position: "absolute",
        top: "-40px",
        left: "0",
        display: "flex",
        alignItems: "center",
        fontFamily: "IBM Plex Sans, System-UI, sans-serif",
        gap: "8px",
        padding: "4px 8px",
        backgroundColor: "#f0f5fd",
        borderRadius: "4px",
        width: "80%",
        zIndex: 10,
        height: "28px",
        minWidth: "200px"
    },
    prefilePreview: {
        position: "absolute",
        top: "-60px",
        left: "0",
        fontFamily: "IBM Plex Sans, System-UI, sans-serif",
        display: "flex",
        alignItems: "center",
        gap: "8px",
        padding: "4px 8px",
        backgroundColor: "#f0f5fd",
        borderRadius: "4px",
        width: "80%",
        zIndex: 10,
        height: "28px"
    },
    filePreviewIcon: {
        color: "#0E497A",
        fontSize: "12px",
        flexShrink: 0
    },
    filePreviewName: {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        fontSize: "13px",
        color: "#0E497A",
        fontWeight: "500",
        flex: 1,
        minWidth: 0
    },
    filePreviewCloseButton: {
        background: "none",
        border: "none",
        cursor: "pointer",
        fontSize: "14px",
        color: "#0E497A",
        padding: "0",
        marginLeft: "8px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "18px",
        height: "18px",
        flexShrink: 0
    }
};
export default CopilotStyles;
